import { render, staticRenderFns } from "./VideoCallHangup.vue?vue&type=template&id=5c60032f&"
import script from "./VideoCallHangup.vue?vue&type=script&lang=ts&"
export * from "./VideoCallHangup.vue?vue&type=script&lang=ts&"
import style0 from "./VideoCallHangup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports